import React, { useEffect, useState } from 'react';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import CommentBox from './CommentBox';
import SharePopup from './SharePopup';
import { usePostContext } from '../context/PostContext';
import FavoriteButton from './FavoriteButton'; // Import the new FavoriteButton component
import { useUserContext } from '../context/UserContext';

const LikeComment = ({ post, defaultShow, GetPoost }) => {

    const [showCommentBox, setShowCommentBox] = useState(false);
    const [showSharePopup, setSharePopup] = useState(false);
    const [likeAnimating, setLikeAnimating] = useState(false);

    const { Notify } = useUserContext();

    const auth = JSON.parse(secureLocalStorage.getItem('auth_data'));
    const [likes, setLikes] = useState(null);
    let userLike = null;
    const [liked, setLiked] = useState(null);
    const [likeId, setLikeId] = useState(null);

    useEffect(() => {
        setLikes(post.likes.length);
        userLike = post.likes.find(like => like.user_id === auth.id);
        setLiked(!!userLike);
        setLikeId(userLike ? userLike.id : null);
    }, [post])






    const handleLike = async () => {
        setLikeAnimating(true);
        try {
            if (liked) {
                if (!likeId) return;
                const response = await axios.post('https://buzzinguniverse.com/backend/api/dislike-request', {
                    id: likeId,
                    post_id: post.post_data.id,
                    user_id: auth.id
                });
                if (response.data.code === 200) {
                    Notify(post.post_data.user_id, `${auth.fname} unliked your post`, `/member/${auth.id}/profile`);
                    setLiked(false);
                    setLikes(likes - 1);
                    setLikeId(null);
                }
            } else {
                const response = await axios.post('https://buzzinguniverse.com/backend/api/like-request', {
                    post_id: post.post_data.id,
                    user_id: auth.id
                });
                if (response.data.code === 200) {
                    setLiked(true);
                    console.log(auth)
                    Notify(post.post_data.user_id, `${auth.fname} liked your post`, `/member/${auth.id}/profile`);
                    setLikes(likes + 1);
                    setLikeId(response.data.data.id);
                }
            }
        } catch (error) {
            console.error("Error liking/disliking post:", error);
            alert(error.response?.data?.message || "Failed to process request");
        } finally {
            setTimeout(() => setLikeAnimating(false), 500);
            GetPoost && GetPoost();
        }
    };

    return (
        <>
            <div className="activity-all-memeber-link-comment">
                <ul>
                    <li>
                        <a
                            href="javascript:;"
                            className={`${liked ? 'liked' : ''} ${likeAnimating ? 'like-animating' : ''}`}
                            onClick={(e) => { e.preventDefault(); handleLike(); }}
                        >
                            <i className="fas fa-thumbs-up" /> {liked ? 'Unlike' : 'Like'} ({likes})
                        </a>
                    </li>
                    <li>
                        <a href="javascript:;" className="activity-comment" onClick={(e) => { e.preventDefault(); setShowCommentBox(!showCommentBox); }}>
                            Comment <span>{post.comments.length}</span>
                        </a>
                    </li>
                    <li>
                        <a href="#" onClick={(e) => { e.preventDefault(); setSharePopup(!showSharePopup); }}>
                            Share <i className="fas fa-plus" />
                        </a>
                    </li>
                    <li>
                        <a href="#" onClick={(e) => { e.preventDefault();}}>
                            {post.post_data.views} Views <i className="fas fa-eye" />
                        </a>
                    </li>
                </ul>
                <FavoriteButton post={post} auth={auth} GetPoost={GetPoost} />
            </div>

            {(showCommentBox || defaultShow) && (
                <CommentBox post={post} auth={auth} GetPoost={GetPoost} setShowCommentBox={setShowCommentBox} />
            )}
            {showSharePopup && <SharePopup setSharePopup={setSharePopup} post={post} auth={auth} />}
        </>
    );
};

export default LikeComment;
